export const IS_BALADY = import.meta.env.VITE_IS_BALADY === 'true';
